import '/vercel/path0/packages/design-system/node_modules/storybook-zeplin/register';